/** The sentence the preview badge explains itself with. */
export function previewNotice(
  brandName: string,
  homeName: string,
  anonymised: boolean,
): string {
  const masked = anonymised
    ? ', och dina kollegors namn är dolda så att kundens team inte syns på skärmen'
    : ''
  return (
    `Du förhandsgranskar CRM:et som ${brandName}. Det här ändrar bara vad du ser i `
    + `den här webbläsaren — ingen annans skärm ändras${masked}. `
    + `Klicka för att gå tillbaka till ${homeName}.`
  )
}
